const saleDocumnetsSchema = [
  {
    name: 'touchpos_always_item_in_new_row',
    initialValue: '',
    input: {
      className: 'touchpos_always_item_in_new_row',
      label: 'Disable rows grouping in document',
      type: 'checkbox',
    },
  },
  {
    name: 'show_original_price_on_receipt',
    initialValue: '',
    input: {
      className: 'show_original_price_on_receipt',
      label: 'Show original price on receipt (online receipt only)',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_enable_default_send_receipt_to_email',
    initialValue: '',
    input: {
      className: 'touchpos_enable_default_send_receipt_to_email',
      label: 'Enable by default send receipt to email',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_autoclose_checkout_final_confirmaton_popup',
    initialValue: '',
    input: {
      className: 'touchpos_autoclose_checkout_final_confirmaton_popup',
      label: 'Automatically close the checkout confirmation window',
      type: 'checkbox',
    },
  },

  {
    name: 'sale_extra_note1',
    initialValue: '',
    input: {
      placeholder: 'Sale note',
      className: 'sale_extra_note1',
      label: 'Sale note 1',
      type: 'input',
    },
  },
  {
    name: 'sale_extra_note2',
    initialValue: '',
    input: {
      placeholder: 'Sale note',
      className: 'sale_extra_note1',
      label: 'Sale note 1',
      type: 'input',
    },
  },
  {
    name: 'sale_extra_note3',
    initialValue: '',
    input: {
      placeholder: 'Sale note',
      label: 'Sale note 3',
      className: 'sale_extra_note3',
      type: 'input',
    },
  },
];

export default saleDocumnetsSchema;
